// removed by extract-text-webpack-plugin
module.exports = {"Menu":"Area__Menu___3e_Cu","MenuChessfilter":"Area__MenuChessfilter___1yi6f","Title":"Area__Title___3-ydg","Inputs":"Area__Inputs___1EuTa","Input":"Area__Input___1wzXv","Dash":"Area__Dash___3aiwR","Button":"Area__Button___2XH38"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/FiltersBar/Filters/Area/Area.scss
// module id = 1339
// module chunks = 0